// /* eslint-disable no-unused-vars */
// import React, { useContext } from 'react';
// import { Navigate, Outlet } from 'react-router-dom';
// import { authContext } from 'contexts/AuthContext';
// import { checkUserRole, hasValidToken } from 'utils';
// import { toast } from 'react-toastify';

// const ProtectedRoute = ({ requiredRoles, children }) => {
//   const { auth, setAuthData } = useContext(authContext);
//   const { loading, data } = auth;

//   if (loading) {
//     return <p>Loading...</p>;
//   }
//   if (data && data.roles) {
//     if (!hasValidToken(data.exp)) {
//       toast.error('Your session has expired, kindly login to continue.');
//       setAuthData(null);
//       return <Navigate to="/login" />;
//     }
//     if (!checkUserRole(data.roles, requiredRoles)) {
//       // If the user doesn't have the required roles, redirect to the unauthorized screen.
//       return <Navigate to="/unauthorized" replace />;
//     }
//     return <Outlet />;
//   }

//   // If the user is not logged in, redirect them to the login screen.
//   return <Navigate to="/login" />;
// };

// export default ProtectedRoute;

/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authContext } from 'contexts/AuthContext';
import { checkUserRole, hasValidToken } from 'utils';
import { toast } from 'react-toastify';
import NotAuthorised from 'pages/NotAuthorised';
import Loader from 'components/common/Loader';
import { collectPermissionNames, hasAnyPermission } from 'utils/permissions';

const ProtectedRoute = ({ requiredRoles, requiredPermissions, children }) => {
  const { auth, setAuthData } = useContext(authContext);
  const { loading, data } = auth;

  // Show loader while auth is loading
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '60vh' }}
      >
        <Loader />
      </div>
    );
  }

  // Check if user is authenticated
  if (!data) {
    return <Navigate to="/login" />;
  }

  // Check if token is valid
  if (!hasValidToken(data.exp)) {
    toast.error('Your session has expired, kindly login to continue.');
    setAuthData(null);
    return <Navigate to="/login" />;
  }

  // Check permissions for routes that require roles
  // If requiredRoles array is empty, allow access (like unauthorized page, 404, etc.)
  if (requiredRoles && requiredRoles.length > 0) {
    if (!checkUserRole(data.roles, requiredRoles)) {
      // User doesn't have the required role, show access denied
      return <NotAuthorised />;
    }
  }

  const permissionCandidates = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : requiredPermissions
      ? [requiredPermissions]
      : [];

  if (permissionCandidates.length > 0) {
    const permissionNames = collectPermissionNames(data);
    if (!hasAnyPermission(permissionNames, permissionCandidates)) {
      return <NotAuthorised />;
    }
  }

  // User has permission, render the page
  return <Outlet />;
};

export default ProtectedRoute;

// /* eslint-disable no-unused-vars */
// import React from 'react';
// import { Outlet } from 'react-router-dom';

// const ProtectedRoute = ({ requiredRoles, children }) => {
//   // ⚡ Temporarily disable all login checks
//   return <Outlet />;
// };

// export default ProtectedRoute;
